import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=a876fc2e&scoped=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=a876fc2e&prod&lang=scss"
import style1 from "./DashboardNavbar.vue?vue&type=style&index=1&id=a876fc2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a876fc2e",
  null
  
)

export default component.exports